import { render, staticRenderFns } from "./clueList.vue?vue&type=template&id=c0c50fb8&scoped=true"
import script from "./clueList.vue?vue&type=script&lang=js"
export * from "./clueList.vue?vue&type=script&lang=js"
import style0 from "./clueList.vue?vue&type=style&index=0&id=c0c50fb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c50fb8",
  null
  
)

export default component.exports